/* eslint-disable */
import { jsx } from 'react/jsx-runtime';
import { createContext, useLayoutEffect, useContext } from 'react';

/* eslint-disable import/prefer-default-export */
// eslint-disable-next-line @typescript-eslint/no-empty-function
function noop() { }

const SentryContext = createContext({
    onLoad: noop,
    init: noop,
    captureMessage: noop,
    captureException: noop,
    configureScope: noop,
    Severity: {},
    withScope: noop,
    Integrations: {},
    setContext: noop
});
function SentryProvider({ children, url, config, integrity, performance = false, tracingOptions }) {
    const Sentry = {
        onLoad: (callback) => { var _a; return (_a = window === null || window === void 0 ? void 0 : window.Sentry) === null || _a === void 0 ? void 0 : _a.onLoad(callback); },
        init: (options) => { var _a; return (_a = window === null || window === void 0 ? void 0 : window.Sentry) === null || _a === void 0 ? void 0 : _a.init(options); },
        captureMessage: (msg, lv) => { var _a; return (_a = window === null || window === void 0 ? void 0 : window.Sentry) === null || _a === void 0 ? void 0 : _a.captureMessage(msg, lv !== null && lv !== void 0 ? lv : 'warning'); },
        captureException: (err, lv) => { var _a; return (_a = window === null || window === void 0 ? void 0 : window.Sentry) === null || _a === void 0 ? void 0 : _a.captureException(err, lv !== null && lv !== void 0 ? lv : 'warning'); },
        configureScope: (callback) => { var _a; return (_a = window === null || window === void 0 ? void 0 : window.Sentry) === null || _a === void 0 ? void 0 : _a.configureScope(callback); },
        withScope: (callback) => { var _a; return (_a = window === null || window === void 0 ? void 0 : window.Sentry) === null || _a === void 0 ? void 0 : _a.withScope(callback); },
        Severity: {
            Critical: 'critical',
            Debug: 'debug',
            Error: 'error',
            Fatal: 'fatal',
            Info: 'info',
            Log: 'log',
            Warning: 'warning'
        },
        Integrations: {},
        setContext: (str, obj) => { var _a; return (_a = window === null || window === void 0 ? void 0 : window.Sentry) === null || _a === void 0 ? void 0 : _a.setContext(str, obj); }
    };
    useLayoutEffect(() => {
        const script = document.createElement('script');
        script.src = url;
        script.crossOrigin = 'anonymous';
        script.type = 'application/javascript';
        const head = document.getElementsByTagName('head')[0];
        let done = false;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        function checkLoadingAndRun() {
            if (!done &&
                (!this.readyState ||
                    this.readyState === 'loaded' ||
                    this.readyState === 'complete')) {
                if (performance) {
                    if (window.Sentry.Integrations.BrowserTracing) {
                        const BrowserTracing = new window.Sentry.Integrations.BrowserTracing.prototype.constructor(tracingOptions);
                        // eslint-disable-next-line no-param-reassign
                        config.integrations = [BrowserTracing];
                    }
                    else {
                        // eslint-disable-next-line @typescript-eslint/no-unused-expressions
                        config.debug
                            ? console.warn("The performance integration needs the right CDN. Please check https://docs.sentry.io/platforms/javascript/install/cdn/#performance-bundle. Performance won't be analyzed.")
                            : null;
                    }
                }
                done = true;
                Sentry.onLoad(() => Sentry.init(config));
            }
        }
        script.onload = checkLoadingAndRun;
        script.onreadystatechange = checkLoadingAndRun;
        if (integrity)
            script.integrity = integrity;
        head.appendChild(script);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [config]);
    return (jsx(SentryContext.Provider, Object.assign({ value: Sentry }, { children: children }), void 0));
}
function useSentry() {
    return useContext(SentryContext);
}

export { SentryProvider, useSentry };
